import { useRenderedBootHumanWait } from '#~/routes/boot-overlay/boot-budget-view.js';
import { getCurrentVendor, Vendor } from '@studio/design-system/themes/vendor.js';
import type { ReactElement } from 'react';
import * as HiveLink from './vendor/hive/link.js';
import * as IrisLink from './vendor/iris/link.js';

/** `<Link>` component. */
export const Link = (): ReactElement => {
  useRenderedBootHumanWait(true);

  const vendor = getCurrentVendor();

  if (vendor === Vendor.IRIS) {
    return <IrisLink.Link />;
  }

  return <HiveLink.Link />;
};
